import React, { KeyboardEvent } from 'react';

import VisuallyHidden from '@reach/visually-hidden';

export interface Props {
  closeHandler: () => void;
  className?: string;
}

const CloseButton: React.FC<React.PropsWithChildren<Props>> = ({ closeHandler, className = '' }) => {
  const onKeyDown = (event: KeyboardEvent) => {
    if ([' ', 'Enter'].includes(event.key)) {
      event.preventDefault();
      closeHandler();
    }
  };
  return (
    <div
      role="button"
      tabIndex={0}
      className={`sc-Modal-close ${className}`}
      onClick={closeHandler}
      onKeyDown={onKeyDown}
    >
      <VisuallyHidden>Close</VisuallyHidden>
      <span aria-hidden="true" className="sc-Icon sc-Icon--s sc-Modal-closeIcon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-label="Close" role="img">
          <title>Close</title>
          <polygon points="14.587 .001 8 6.588 1.413 .001 0 1.414 6.587 8.001 0 14.588 1.413 16 8 9.414 14.587 16 16 14.588 9.413 8.001 16 1.414" />
        </svg>
      </span>
    </div>
  );
};

export default CloseButton;
